import React from 'react';
import { SingleSelectMenu } from '../../../../../../components/Dropdown';
import { FunnelTimeToConvertMetric } from '../../../../../../utils/apollo/graphqlSchema';

interface IProps {
  selectedMetric: FunnelTimeToConvertMetric | null;
  onChange: (metric: string) => void;
}

const FunnelTimeToConvertMetricSelect = ({
  selectedMetric,
  onChange,
}: IProps) => {
  const options = [
    {
      text: 'Average',
      value: FunnelTimeToConvertMetric.Average,
    },
    {
      text: 'Median',
      value: FunnelTimeToConvertMetric.Median,
    },
  ];

  return (
    <SingleSelectMenu
      options={options}
      value={selectedMetric}
      onChange={onChange}
      placeholder={'Select metric'}
    />
  );
};

export default FunnelTimeToConvertMetricSelect;
